import React, { FC, PropsWithChildren, ReactNode } from "react"
import styled from "styled-components"
import { Container, FlexContainer, useBreakpointComponent } from "@carrotfertility/carotene"
import { useUserRole } from "components/partner-access/hooks/usePartnerAccess"
import { PartnerAccessAccountBanner } from "components/partner-access/PartnerAccessBanner"
import { LegacyUserDropdownPositioner, UserDropdown } from "features/user-dropdown"
import { useMediaQuery, useTheme } from "@carrotfertility/carotene-core"

type MasterLayoutProps = {
  header: ReactNode
  children: ReactNode
  footer?: ReactNode
}

const FooterContainer = styled.div`
  margin-top: auto;
`
const footerSupportClasses = "flex flex-column h-100"

/**
 * We should refactor this component to not use Tachyons when it's not busy season
 */
const MasterLayout: FC<MasterLayoutProps> = ({ header, children, footer }: MasterLayoutProps) => {
  const { isPartnerAccessingAccount } = useUserRole()
  const theme = useTheme()
  const showUserDropdown = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <div style={{ maxWidth: "100vw" }} className="w-100 flex flex-column items-center ph45-l ph35-m ph35-s">
      <div className={`mw-968-l mw-600-m w-100${footer ? ` ${footerSupportClasses}` : ""}`}>
        {showUserDropdown ? (
          <LegacyUserDropdownPositioner>
            <UserDropdown />
          </LegacyUserDropdownPositioner>
        ) : null}
        {header}
        {isPartnerAccessingAccount && <PartnerAccessAccountBanner />}
        <div className="mt4 mt35-s mb45-ns mb55">{children}</div>
        {footer && <FooterContainer>{footer}</FooterContainer>}
      </div>
    </div>
  )
}

type SingleColumnLayoutProps = {
  header: ReactNode
}

export function SingleColumnLayout({ header, children }: PropsWithChildren<SingleColumnLayoutProps>): JSX.Element {
  const element = useBreakpointComponent([
    false,
    false,
    <LegacyUserDropdownPositioner key={"notSmall"}>
      <UserDropdown />
    </LegacyUserDropdownPositioner>
  ])
  return (
    <FlexContainer paddingLeftRight={["medium", "huge"]} alignItems="center" justifyContent="center">
      <FlexContainer stack={["96px", null, "huge"]} height="100%" maxWidth="968px" direction="column" gap="32px">
        <Container height={["64px", null, "192px"]}>
          {element}
          {header}
        </Container>
        <Container height="100%">{children}</Container>
      </FlexContainer>
    </FlexContainer>
  )
}

export { MasterLayout }
